import React from 'react';

import {
    Div,
    FormItem,
    Input,
    SplitLayout,
    SplitCol,
    Button, Group, ButtonGroup, SimpleCell, Switch
} from '@vkontakte/vkui';
import axios from "axios";
import * as constants from "../assets/constants";
import {Icon12CheckCircle, Icon16ArrowshapeRightOutline, Icon24InfoCircleOutline} from "@vkontakte/icons";
import CartApi from "../api/CartApi";
import cartApi from "../api/CartApi";
import HelpButton from "../assets/HelpButton";
import checkMods from "./checkMods";
import CopyToClipBoard from "../assets/CopyToClipboardButton";
import {
    AdaptivityContext,
    checkGroupBlocked,
    checkNarezkaForUral,
    checkProductBlocked,
    formatQnt,
    getProductOrderBlock,
    getScladBlockReason,
    formatOrderBlockHelpText,
    keyBase,
    keyUnique
} from "../assets/constants";
import BaseComponent from "../components/BaseComponent";

class Series extends BaseComponent {
    state = {
        items: [],
        showMods: false
    }

    receiveMessage = (event) => {
        if (event.data == 'modalBack') {
            if (this.state.showMods) {
                this.modalBack()
            }
        }
    }

    constructor(props) {
        super(props);
        this.modalBack = () => {
            this.setState({showMods: false})
            this.props.parent.setState({disableModalBack: false})
        };
    }


    componentDidMount() {
        super.componentDidMount()

        this.getItems()
    }

    sortCurrentSeries = (series, setState = true) => {

        let old = series


        old.sort(function (a, b) {

            if (a.ost_qnt * 1 == b.ost_qnt * 1) return 0;

            return a.ost_qnt * 1 > b.ost_qnt * 1 ? 1 : -1;

        });

        if (setState) {
            old.map((el, i) => {
                old[i].ost_qnt = (el.ost_qnt * this.props.product.unit.K / this.props.current_unit.K)
            })
            this.setState({items: old})
        }
        return old
    }


    getItems = () => {


        if (this.props.product.isUnique == '1') {

            const series = []

            console.log(this.props)
            if (this.props.qntBase && this.props.qntBase * 1 > 0.0001) {
                series.push({
                    ost_id: keyBase,
                    base_unit: this.props.product.base_unit.external_id,
                    pack_unit: this.props.product.pack_unit.external_id,
                    ost_unit: this.props.product.ost_unit,
                    code: 'Секция Б',
                    ost_qnt: this.props.qntBase,
                    series_id: keyBase,
                    id: this.props.product.id,
                    product_id: this.props.product.id,
                    product: this.props.product,
                    name: this.props.product.name
                })
            }
            if (this.props.qntUnique && this.props.qntUnique > 0.0001) {
                series.push(
                    {
                        ost_id: keyUnique,
                        base_unit: this.props.product.base_unit.external_id,
                        pack_unit: this.props.product.pack_unit.external_id,
                        ost_unit: this.props.product.ost_unit,
                        code: 'Секция У',
                        ost_qnt: this.props.qntUnique,
                        series_id: keyUnique,
                        id: this.props.product.id,
                        product_id: this.props.product.id,
                        product: this.props.product,
                        name: this.props.product.name
                    })
            }
            series.map((el, index) => {
                const qnt = CartApi.getSeriesCartQnt(el.ost_id, this.props.product.id)
                const cart_id = CartApi.getSeriesCartId(el.ost_id, this.props.product.id)

                if (qnt) {
                    el.quantity = qnt
                    el.cart_id = cart_id
                    el.order_unit = this.props.current_unit
                }
            })
            this.sortCurrentSeries(series)

            return
        }

        const body = new FormData()
        body.append('product_id', this.props.product.id)
        body.append('sclad_id', this.props.sclad.sclad_id)

        if (this.props.sclad.cart_id != undefined) {
            body.append('series_id', this.props.sclad.series_id)
        }
        let sAjaxSource = '/?app=partnersproducts&act=getSeries';

        this.setState({
            items: []
        });
        axios.post(this.props.base_url + sAjaxSource, body,
            {
                withCredentials: true
            }
        ).then((response) => {

            if (response.data.width.value) {
                response.data.width.value = response.data.width.value.toString().replace(",", ".")
            }
            this.setState({width: response.data.width})

            const series = response.data.results
            series.map((el, index) => {
                const qnt = CartApi.getSeriesCartQnt(el.ost_id, this.props.product.id)
                const cart_id = CartApi.getSeriesCartId(el.ost_id, this.props.product.id)
                if (qnt) {
                    el.quantity = qnt
                    el.cart_id = cart_id
                    el.order_unit = this.props.current_unit
                }
            })
            this.sortCurrentSeries(series)

        })

    }


    addOrEditToCart_ = () => {
        let hasErrors = false;
        let i;
        let len = this.state.items.length
        for (i = 0; i < len; i++) {
            let item = this.state.items[i];
            if (item.order_qnt != undefined && item.order_qnt * 1 > 0) {

                hasErrors = !item.seria;

                if (!hasErrors) {
                    cartApi.removeSeriaInCart(item.seria.ost_id)

                    item.sclad_id = this.props.sclad.sclad_id
                    item.series_id = item.seria.ost_id
                    item.series_code = item.seria.code
                    item.meta_id = this.props.product.id
                    item.name = this.props.product.name
                    item.unit_id = this.props.current_unit.external_id
                    item.unit_name = this.props.current_unit.title
                    item.unit = this.props.current_unit

                    item.quantity = (item.order_qnt * 1).toFixed(3).toString().replace('.000', '')
                    if (this.props.sclad.unit_price) {
                        item.price = ((this.props.sclad.is_manual ? this.props.sclad.manual_price : this.props.sclad.base_price) * this.props.current_unit.K / this.props.sclad.unit_price.K).toFixed(2).toString().replace('.00', '')
                        item.discount = this.props.sclad.discount
                        item.unit_price = this.props.sclad.unit_price
                    } else {
                        item.price = 0.0;
                    }
                    if (item.cart_id != undefined) {
                        // item.id = item.cart_id
                    }
                    CartApi.addOrEdit(item)

                } else {
                    this.setState(hasErrors)
                    break;
                }
            }
        }
        if (!hasErrors) {
            CartApi.saveItems()
            this.props.hideScissors();
        }
    }
    addAllQnt = (index) => {
        let old = this.state.items;
        let item_ = old[index]
        console.log(item_.ost_qnt)
        old[index].quantity = item_.ost_qnt * 1//(item_.ost_qnt * this.props.product.unit.K / this.props.current_unit.K).toFixed(4).toString().replace('.0000', '')
        old[index].order_unit = this.props.current_unit
        old[index].from_mods = false
        //console.log(item_)
        this.setState({items: old});
    }
    changeOrder = (e, index) => {

        let value = e.target.value.replace(',', '.')
        const match = value.match('([0-9]+[\.\,]?([0-9]{1,3})?)')
//        console.log(match)
        if (value !== '') {
            if (!match || value * 1 == 0) return
        }
        this.noRender = true
        let old = this.state.items;
        old[index].quantity = match ? match[0] : ''
        old[index].order_unit = this.props.current_unit
        old[index].from_mods = false
        this.setState({items: old});
    }
    addOrEditToCart = async () => {
        const orderBlock = this.getOrderBlock()
        if (orderBlock.blocked) {
            return
        }

        const simpleCartHasFirmFit = CartApi.getFirmFitCartQnt() > 0
        const no_deny_firm_fit_club = this.props.current_user.meta.settings && this.props.current_user.meta.settings.no_deny_firm_fit_club == '1'
        if (!no_deny_firm_fit_club) {
            if (this.props.product.is_firm_fit == '0' && simpleCartHasFirmFit) {
                window.postMessage({
                    timeout: 8000,
                    type: 'error',
                    text: 'В корзине есть товар из Firm Fit Club. Не возможно добавить товар из общего каталога в корзину. Пожалуйста создайте второй заказ без товаров производителя Firm Fit или очистите корзину от товаров производителя Firm Fit'
                })
                return
            }
            if (this.props.product.is_firm_fit == '1' && !simpleCartHasFirmFit && CartApi.items.length > 0) {
                window.postMessage({
                    timeout: 8000,
                    type: 'error',
                    text: 'В корзине есть товар из общего каталога. Не возможно добавить товар из Firm Fit Club в корзину. Пожалуйста создайте второй заказ без товаров производителя общего каталога или очистите корзину от товаров общего каталога'
                })
                return
            }
        }
        let hasErrors = false;
        let i;
        let len = this.state.items.length
        const krat_unit = this.props.product.krat_unit
        const mods = new checkMods({...this.props, keyBase}, {current_unit: this.props.current_unit, ...this.state})

        const newItems = []

        for (i = 0; i < len; i++) {
            let item = this.state.items[i];
            if (item.quantity != undefined && item.quantity * 1 > 0) {

                hasErrors = await mods.checkMods(item, i)
                if (hasErrors === false) {
                    item.id = undefined
                    item.sclad_id = this.props.sclad.sclad_id;
                    item.sclad_name = this.props.sclad.sclad_name;
                    item.series_id = item.ost_id;
                    item.series_code = item.code;
                    item.meta_id = this.props.product.id;

                    let {current_unit} = this.props


                    if (krat_unit !== null) {
                        current_unit = krat_unit
                    }

                    item.unit_id = current_unit.external_id
                    item.unit_name = current_unit.title
                    item.unit = current_unit

                    //item.quantity = (item.quantity * 1).toFixed(3).toString().replace('.000', '')
                    item.quantity = (item.quantity * item.order_unit.K / current_unit.K).toFixed(3).toString().replace('.000', '')

                    if (this.props.sclad.unit_price) {
                        item.price = ((this.props.sclad.is_manual ? this.props.sclad.manual_price : this.props.sclad.base_price) * current_unit.K / this.props.sclad.unit_price.K).toFixed(2).toString().replace('.00', '')
                        item.discount = this.props.sclad.discount
                        item.unit_price = this.props.sclad.unit_price
                    } else {
                        item.price = 0.0;
                    }
                    if (item.cart_id != undefined && !item.new_piece) {
                        item.id = item.cart_id
                        item.cart_id = item.cart_id
                    }
                    newItems.push(item)
                    //CartApi.addOrEdit(item)
                } else {
                    if (hasErrors === true) break
                    this.props.parent.setState({disableModalBack: true})
                    this.setState({current_item: item, current_index: i, ...hasErrors})
                    this.setState({showMods: true})
                    break;
                }
            }
        }
        if (!hasErrors) {
            //   console.log(newItems)
            newItems.map(el => CartApi.addOrEdit(el))

            CartApi.saveItems()
            this.props.hideSeries()
        }
    }
    setCurrentQnt = (qnt, index, unit, dont_mods = false) => {
        let old = this.state.items;
        let item_ = old[index]
        old[index].quantity = (qnt * this.state.current_item.order_unit.K / unit.K).toFixed(3).toString().replace('.0000', '').replace('.000', '')
        old[index].order_unit = unit
        old[index].from_mods = true
        if (dont_mods) {
            old[index].dont_mods = true
        }
        console.log(item_)
        this.setState({items: old});
        this.props.setCurrentUnit(unit.external_id)
        this.modalBack()
    }

    getOrderBlock = () => {
        const productOrderBlock = getProductOrderBlock(this.props.product, this.props.user)
        const scladBlockReason = getScladBlockReason(this.props.sclad)

        let groupAndScladBlocked = checkGroupBlocked(this.props.product.path, this.props.sclad.sclad_external_id)
        if (!groupAndScladBlocked) {
            groupAndScladBlocked = checkProductBlocked(
                this.props.inventarisation_data,
                this.props.sclad.sclad_external_id,
                this.props.product.id
            )
        }

        const blocked = scladBlockReason.blocked || productOrderBlock.blocked || !!groupAndScladBlocked
        const reason_text = groupAndScladBlocked ? groupAndScladBlocked
            : (productOrderBlock.blocked ? productOrderBlock.reason_text : scladBlockReason.reason_text)

        return {blocked, reason_text, groupAndScladBlocked}
    }

    render() {
        setTimeout(() => this.noRender = false, 500)
        if (this.state.showMods) {
            return (
                <Group style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "start",
                    padding: "12px"
                    /*background: "#0f65b9",
                    color: "white"*/
                }}>
                    <div>
                        <p>{'Укажите варианты заказа в ' + this.props.current_unit.title + ', кратный единице измерения "' + (this.state.current_pack_unit || this.props.product.pack_unit).title + '"'}</p>
                        {this.state.current_item == undefined ? '' : this.props.product.units.map((itemU, indexU) => {
                                if (this.props.product.isUnique == '1' || this.props.product.krat_unit) {
                                    if (itemU.external_id != this.props.product.pack_unit.external_id) return
                                }
                                return <ButtonGroup mode="horizontal" stretched style={{marginBottom: "12px"}}>

                                    <Button stretched
                                            onClick={() => this.setCurrentQnt(this.state.current_min, this.state.current_index, itemU, this.props.product.isUnique == '1')}>
                                        {(this.state.current_min * this.state.current_item.order_unit.K / itemU.K).toFixed(3).toString().replace('.0000', '').replace('.000', '') + itemU.title}
                                    </Button>
                                    <Button stretched
                                            onClick={() => this.setCurrentQnt(this.state.current_max, this.state.current_index, itemU, this.props.product.isUnique == '1')}>
                                        {(this.state.current_max * this.state.current_item.order_unit.K / itemU.K).toFixed(3).toString().replace('.0000', '').replace('.000', '') + itemU.title}
                                    </Button>
                                    {!this.props.product.krat_unit && this.props.product.isUnique != '1' &&
                                        <Button stretched disabled={this.props.ffc_mode === true}
                                                onClick={() => this.setCurrentQnt(this.state.current_item.quantity, this.state.current_index, itemU, true)}>
                                            {(this.state.current_item.quantity * this.state.current_item.order_unit.K / itemU.K).toFixed(3).toString().replace('.0000', '').replace('.000', '') + itemU.title}
                                        </Button>}


                                </ButtonGroup>
                            }
                        )}
                    </div>
                </Group>
            )
        } else {
            const orderBlock = this.getOrderBlock()
            const {blocked: orderDisabled, reason_text: orderHelpText, groupAndScladBlocked} = orderBlock

            let narezka = checkNarezkaForUral(this.props.product)
            if (this.props.product.rulon && this.props.product.rulon.value == 'да') {
                narezka = true
            }
            return (
                <Div>
                    <SplitLayout>
                        <SplitCol>
                            <FormItem style={{textAlign: "right"}}>
                                <Button size="l" before={<Icon12CheckCircle/>} stretched
                                        disabled={this.props.current_user.tech_docs_blocked == '1' || orderDisabled}
                                        onClick={() => {
                                            this.addOrEditToCart()
                                        }}>Подтвердить</Button>
                            </FormItem>

                        </SplitCol>
                    </SplitLayout>
                    <SplitLayout style={{marginBottom: "50px"}}>
                        <SplitCol>
                            {this.state.items ? this.state.items.map((series_item, index) => (
                                <SplitLayout style={{alignItems: 'center', borderBottom: '#dadada 1px solid'}}>
                                    <SplitCol width={40}>
                                        <FormItem style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            wordBreak: AdaptivityContext.isMobile ? "break-all" : "inherit"
                                        }}>
                                            {series_item.code ? [series_item.code,
                                                <CopyToClipBoard style={{marginTop: '0px', minWidth: '36px'}}
                                                                 text={series_item.code}/>] : 'Код серии не задан'}
                                        </FormItem>
                                    </SplitCol>
                                    <SplitCol>
                                        <FormItem style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            flexDirection: AdaptivityContext.isMobile ? 'column' : 'row'
                                        }}>
                                            {series_item.ost_qnt.toFixed(3).toString().replace('.000', '')}
                                            <b>{this.props.current_unit.title}</b>
                                            <Button mode="primary" size="s" mode="secondary"
                                                    disabled={orderDisabled || series_item.ost_qnt.toFixed(4) == 0}
                                                    onClick={() => this.addAllQnt(index)}>
                                                <Icon16ArrowshapeRightOutline/>
                                            </Button>
                                        </FormItem>
                                    </SplitCol>
                                    <SplitCol style={{marginLeft: '15px'}}
                                              width={constants.AdaptivityContext.isMobile ? 28 : ''}>
                                        <div className="order-input-wrapper">
                                            <Input className={constants.AdaptivityContext.isMobile ? "order-input" : ""}
                                                   onChange={(e) => this.changeOrder(e, index)}
                                                   disabled={orderDisabled}
                                                   value={this.noRender ? series_item.quantity : (series_item.order_unit ? formatQnt(series_item.quantity * series_item.order_unit.K / this.props.current_unit.K, true) : '')}
                                                   type="text"
                                            />
                                            {orderDisabled ?
                                                <HelpButton style={{color: groupAndScladBlocked ? 'red' : ''}}
                                                            icon={groupAndScladBlocked ?
                                                                <Icon24InfoCircleOutline/> : null}
                                                            text={formatOrderBlockHelpText(orderHelpText)}/> : ''}
                                        </div>
                                        {this.props.current_user.partner_id == '57' && !(series_item.cart_id === undefined || this.props.sclad.is_rip == '0'
                                            || orderDisabled
                                            || !narezka) ?
                                            <SimpleCell Component="label"
                                                        after={<Switch onChange={(e) => this.changeNewPiece(e, index)}
                                                                       checked={series_item.new_piece}/>}>
                                                <span style={{fontSize: "x-small"}}>Отрезать еще</span>
                                            </SimpleCell> : ''}
                                    </SplitCol>
                                </SplitLayout>)) : ''}
                        </SplitCol>

                    </SplitLayout>
                </Div>
            )
        }
    }


    changeNewPiece = (e, index) => {
        const olds = this.state.items
        const old = olds[index]

        old.new_piece = e.currentTarget.checked
        olds[index] = old
        this.setState({items: olds})
    }
}

export default Series